module.exports = __webpack_public_path__ + "img/upper-arrow.f48588cd.svg";